import {Application} from "@hotwired/stimulus"
import TabsController from "../controllers/tabs_controller.js"
import SubmissionWarningController from "../controllers/submission_warning_controller.js"

const application = Application.start()

application.debug = true

application.register("tabs", TabsController)
application.register("submission-warning", SubmissionWarningController)

// eslint-disable-next-line no-console
console.log("Vite ⚡️ Rails & Jaamo Parent App")

export {application}
